module.exports = __webpack_public_path__ + "static/johns_hopkins.b2321be6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/collaborators/johns_hopkins.png
// module id = 158
// module chunks = 29096074603545 74537795826934 162898551421021